import { Badge } from "@/components/ui/badge";

type OnboardingStatus = 'draft' | 'kyc_pending' | 'data_pending' | 'review' | 'active';

interface OnboardingStatusBadgeProps {
  status: OnboardingStatus | string | null | undefined;
  className?: string;
}

const STATUS_CONFIG: Record<OnboardingStatus, { label: string; variant: "default" | "secondary" | "outline" | "destructive"; className: string }> = {
  draft: {
    label: "Draft",
    variant: "outline",
    className: "bg-gray-100 text-gray-700 border-gray-200",
  },
  kyc_pending: {
    label: "KYC Pending",
    variant: "outline",
    className: "bg-yellow-50 text-yellow-700 border-yellow-200",
  },
  data_pending: {
    label: "Data Pending",
    variant: "outline",
    className: "bg-blue-50 text-blue-700 border-blue-200",
  },
  review: {
    label: "In Review",
    variant: "outline",
    className: "bg-purple-50 text-purple-700 border-purple-200",
  },
  active: {
    label: "Active",
    variant: "outline",
    className: "bg-green-50 text-green-700 border-green-200",
  },
};

export function OnboardingStatusBadge({ status, className }: OnboardingStatusBadgeProps) {
  const normalizedStatus = (status || 'draft') as OnboardingStatus;
  const config = STATUS_CONFIG[normalizedStatus] || STATUS_CONFIG.draft;

  return (
    <Badge
      variant={config.variant}
      className={`${config.className} ${className || ''}`}
    >
      {config.label}
    </Badge>
  );
}
